// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"Tag_tagContainer__axqx_","tagCloseButton":"Tag_tagCloseButton__B-L1R","CloseIcon":"Tag_CloseIcon__QszSK"};